import React from "react";

export const percentileShades = [
  "#cd2525",
  "#d02c29",
  "#d1342c",
  "#d33a31",
  "#d53e34",
  "#d64337",
  "#d8493b",
  "#da4e3f",
  "#db5343",
  "#dd5746",
  "#df5b4b",
  "#e0604e",
  "#e16452",
  "#e46956",
  "#e46d59",
  "#e6725e",
  "#e87661",
  "#e97a65",
  "#ea7f68",
  "#ec836c",
  "#ec8771",
  "#ee8b75",
  "#f08f79",
  "#f0937d",
  "#f19781",
  "#f39b85",
  "#f49f89",
  "#f4a38d",
  "#f6a791",
  "#f7ab96",
  "#f7af9a",
  "#f8b49e",
  "#fab7a2",
  "#fabba6",
  "#fac0aa",
  "#fbc3b0",
  "#fcc7b3",
  "#fdcbb8",
  "#fdd0bb",
  "#fdd4c0",
  "#fdd7c4",
  "#fedbc8",
  "#fedfcd",
  "#fee3d2",
  "#ffe7d5",
  "#ffebda",
  "#ffefde",
  "#fff3e3",
  "#fffbec",
  "#fffbec",
  "#fffff0",
  "#fcffec",
  "#f8fde8",
  "#f4fae4",
  "#f2fde1",
  "#eefbdc",
  "#eafad8",
  "#e8f9d3",
  "#e3f8cf",
  "#e0f7cc",
  "#ddf6c7",
  "#d9f6c3",
  "#d6f5c0",
  "#d2f5bb",
  "#cef4b8",
  "#cbf3b3",
  "#c7f2af",
  "#c3f1ab",
  "#c0efa7",
  "#bceea3",
  "#b8ed9f",
  "#b4ec9b",
  "#b1eb97",
  "#adeb93",
  "#a9ea8f",
  "#a5e98b",
  "#a1e787",
  "#9de682",
  "#99e57e",
  "#95e47a",
  "#91e376",
  "#88e26e",
  "#84e169",
  "#84e169",
  "#80df65",
  "#7bde61",
  "#77dd5c",
  "#71dc57",
  "#6ddc54",
  "#68d94e",
  "#63d84a",
  "#5cd746",
  "#55d540",
  "#4dcf38",
  "#4ad535",
  "#43d42f",
  "#3bd229",
  "#32d022",
  "#29cf1c",
  "#1fcf11",
  "#15ce00",
];

export const getOrdinal = (num) => {
  return ["th", "st", "nd", "rd"][Math.abs(~[1, 2, 3].indexOf(+(+num).toFixed().substr(-1)))];
};

const Percentile = ({ data = null, additionalStyles = {} }) => {
  const percentileNum = data === null ? "N/A" : data.replace(/[^0-9]/g, "");
  return (
    <div
      className="Percentile"
      style={{
        color: percentileNum >= 90 || percentileNum <= 10 ? "white" : "black",
        ...additionalStyles,
        background: `${percentileNum !== "N/A" && percentileShades[percentileNum]}`,
      }}
    >
      {percentileNum !== "N/A" && percentileNum !== "" ? (
        <span>
          {percentileNum}
          {/* <sup>{data.replace(/[^A-Za-z]/gi, "")}</sup> */}
          <sup className="ml-1">{getOrdinal(percentileNum)}</sup>
        </span>
      ) : (
        <span style={{ color: "black" }}>N/A</span>
      )}
    </div>
  );
};

export default Percentile;
